import { render, staticRenderFns } from "./GalleryEditingAreaModalComponent.vue?vue&type=template&id=c33a9cdc&scoped=true&"
import script from "./GalleryEditingAreaModalComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryEditingAreaModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEditingAreaModalComponent.vue?vue&type=style&index=0&id=c33a9cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33a9cdc",
  null
  
)

export default component.exports